<ng-container *ngIf='pageNumbers.length!=0'>
    <div class='d-flex pagination-container'>

        <div *ngIf="showDetail" style="margin-right: 28px; margin-top: 9px">
            <span>Showing records {{showingFrom}} to {{showingTo}} of {{totalrecords}}</span>
        </div>

        <ng-container *ngIf='!(prevPageDisabler <= maxDisplayedPages)'>
            <i style="margin-right: 5px" (click)='firstPage()' class="fa fa-step-backward" title="First page" aria-hidden="true"></i>
        </ng-container>

        <ng-container *ngIf='!(prevPageDisabler <= maxDisplayedPages);'>
            <i style="margin-right: 10px" (click)='prevPages()' class="fa fa-chevron-left" title="Previous page" aria-hidden="true"></i>
        </ng-container>

        <div *ngFor="let pageNumber of pageNumbers; let i=index">
            <button class="pagination-button" [ngClass]="{'active-page': pageNumber === selectedPage}" (click)='selectPage(pageNumber)'>{{pageNumber}}</button>
        </div>

        <ng-container *ngIf='!(prevPageDisabler === totalPages)'>
            <i (click)='nextPages()' class="fa fa-chevron-right" title="Next page" aria-hidden="true"></i>
        </ng-container>

        <ng-container *ngIf='!(prevPageDisabler === totalPages)'>
            <i style="margin-left: 5px" (click)='lastPage()' class="fa fa-step-forward" title="Last page" aria-hidden="true"></i>
        </ng-container>

    </div>
</ng-container>